// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"ed2e3bb3","623":"5adbd385","873":"28b45fee","974":"8ad5248e"}[chunkId] + ".chunk.css";
};